<!-- filter and search -->
<div class="d-flex align-items-start dl-table-filter">
  <!-- status filter -->
  <div class="d-flex align-items-center justify-content-start">
    <div *ngIf="entityType && tableConfiguration.filters?.length > 0" class="dl-table-filter-container">
      <span class="dl-table-filter-title">Filter:</span>
      <div *ngFor="let filter of tableConfiguration.filters" class="dl-{{entityType.toString()}}-status dl-clickable"
        [ngClass]="isFilterActivated(filter) ? 'dl-' + entityType + '-status-' + filter.toLowerCase() : 'dl-table-filter-inactive'"
        (click)="onFilterClick(filter)">
        {{filter}}
      </div>
    </div>
  </div>
  <!-- search -->
  <mat-form-field *ngIf="tableConfiguration.search.enabled" appearance="outline" class="dl-search">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput placeholder="{{tableConfiguration.search.placeholder | default:'Search...'}}"
      (keyup)="keyUp($event)">
  </mat-form-field>
</div>

<!-- table -->
<table mat-table [dataSource]="dataSource" matSort [matSortActive]="defaultSortField" matSortDisableClear
  [matSortDirection]="defaultSortDirection" multiTemplateDataRows>
  <caption class="d-none">Available items</caption>

  <!-- columns definition -->

  <ng-container matColumnDef="creationTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('creationTime')}}</th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.creationTime | date:'dd.MMM.yy'}}</div>
      <div class="dl-table-cell-label">{{element.creationTime| zoneDate:'HH:mm'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="lastModifiedTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('lastModifiedTime')}}
    </th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.lastModifiedTime | date:'dd.MMM.yy'}}</div>
      <div class="dl-table-cell-label">{{element.lastModifiedTime| zoneDate:'HH:mm'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('name')}}</th>
    <td mat-cell *matCellDef="let element">
      <div class="dl-table-item-name">{{element.name}}</div>
      <div class="dl-table-cell-label">{{element.displayId}}
        <span *ngIf="element.status === 'Updating'">
          | <span class="dl-request-in-progress">In Progress...</span>
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('type')}}</th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.type}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('status')}}</th>
    <td mat-cell *matCellDef="let element">
      <div class="dl-{{getEntityType(element)}}-status dl-{{getEntityType(element)}}-status-{{element.status.toLowerCase()}}">
        {{element.status}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="custodianName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('custodianName')}}</th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.custodianName}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="requestorName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('requestorName')}}</th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.requestorName}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="collectionName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('collectionName')}}
    </th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.collectionName}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="creatorName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">{{getColumnTitle('creatorName')}}</th>
    <td mat-cell *matCellDef="let element">
      <div>{{element.creatorName}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="d-flex align-items-center justify-content-end">
        <mat-icon aria-hidden="false" aria-label="history" class="dl-action-icon"
          [ngClass]="{'icon-active': element == expandedElement}" (click)="openDetails($event, element)">
          history
        </mat-icon>
      </div>
    </td>
  </ng-container>

  <!-- DUR custom row template -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="8" class="dl-expandable-row"
      [ngClass]="{'dl-expandable-row-expanded': element == expandedElement}">
      <div class="dl-expandable-container" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <div class="d-flex flex-column dl-history">
          <div class="dl-scroll-button dl-scroll-button-left" (click)="scrollLeft(drag)" [hidden]="drag.currIndex == 0">
            <mat-icon aria-hidden="false" aria-label="chevron_left" class="dl-action-icon icon-light">
              chevron_left</mat-icon>
          </div>
          <div class="dl-scroll-button dl-scroll-button-right" (click)="scrollRight(drag)"
            [hidden]="!rightScrollVisibility[getVisibilityIndex(drag)]">
            <mat-icon aria-hidden="false" aria-label="chevron_right" class="dl-action-icon icon-light">
              chevron_right</mat-icon>
          </div>
          <div class="dl-history-header">
            History
          </div>
          <drag-scroll [scrollbar-hidden]="true" #drag class="d-flex flex-row drag-scroll"
            (dragEnd)="checkIfRightScrollAvailable(drag)">
            <div drag-scroll-item *ngFor="let history of element.histories; let i = index;"
              class="d-flex flex-row dl-history-block">
              <div class="d-flex flex-column dl-history-container">
                <div class="dl-history-date">
                  {{history.changeTime | date: "dd.MMM.yy"}} |
                  {{history.changeTime | zoneDate:"HH:mm"}}
                </div>
                <div class="d-flex flex-row dl-history-state-container">
                  <div class="dl-history-request-number">
                    {{history.entityDisplayId}}
                  </div>
                  <div class="dl-request-status dl-request-status-{{history.newState.toLowerCase()}}">
                    {{history.newState}}
                  </div>
                </div>
              </div>
              <div class="dl-history-next-arrow" *ngIf="i < element.histories.length - 1">
                <mat-icon aria-hidden="false" aria-label="arrow_forward" class="icon-dark">
                  arrow_forward</mat-icon>
              </div>
            </div>
          </drag-scroll>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="dl-table-element-row"
    [routerLink]="getLink(element)" routerLinkActive="active">
  </tr>

  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="dl-detail-row"></tr>
</table>

<!-- load more -->
<div class="d-flex align-items-center justify-content-center">
  <button type="button" class="btn dl-btn dl-page-header-btn dl-btn-secondary" (click)="loadWorkItems()" *ngIf="continuationToken">
    <div class="d-flex align-items-center">
      <div>Load more</div>
    </div>
  </button>
  <span class="dl-page-header-btn" *ngIf="!continuationToken">No more data available</span>
</div>

<!-- loading spinner -->
<div class="d-flex align-items-center justify-content-center dl-spinner" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
